<template>
    <v-btn
        :rounded="0"
        :variant="props.bordered ? 'outlined' : 'tonal'"
        :loading="loading"
        :disabled="disabled"
        :class="buttonClasses"
        :height="props.height"
    >
        <template #prepend>
            <slot name="prepend" />
        </template>

        {{ props.text }}

        <template #append>
            <slot name="append" />
        </template>
    </v-btn>
</template>

<script setup>
import { computed } from 'vue';

import { IS_BACKGROUND_DARK } from '@/themes/theme';

const props = defineProps({
    text: {
        type: String
    },
    loading: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    bordered: {
        type: Boolean,
        default: false
    },
    height: {
        type: Number,
        default: 56
    }
});

const buttonClasses = computed(() => {
    if (props.bordered) {
        return 'text-black bg-white';
    }

    return ['text-white bg-black', { 'button-dark-contrast': IS_BACKGROUND_DARK }];
});
</script>

<style scoped>
.button-dark-contrast {
    background-color: #4b4b4b !important;
}
</style>
